export enum APP_PLATFORM {
  WEB_PORTAL = "web_portal",
  ANDROID_APP = "android_app",
  IOS_APP = "ios_app",
  WEB_CP = "web_cp",
}
